import { ListProps } from "@p0security/ui";
import { DisplayList } from "components/Assessment/components/node/shared";
import VirtualList from "rc-virtual-list";
import { Key, ReactNode } from "react";

export interface ConditionalVirtualListProps<T> extends Omit<
  ListProps<T>,
  "dataSource"
> {
  data: T[];
  renderItem: (item: T, index: number) => ReactNode;
  virtualThreshold?: number;
  height?: number;
  itemHeight?: number;
  itemKey?: Extract<keyof T, Key> | "key";

  width?: string;
}

// itemHeight cannot be unset
// This will significantly slow down the list rendering
export const ConditionalVirtualList = <
  T extends ReactNode | Record<string, any>,
>({
  data,
  renderItem,
  virtualThreshold = 50,
  height = 228,
  itemHeight = 10,
  itemKey = "key",
  width = "100%",
  ...listProps
}: ConditionalVirtualListProps<T>) => {
  const shouldUseVirtual =
    data.length > virtualThreshold && itemKey && renderItem;

  if (shouldUseVirtual) {
    return (
      <DisplayList
        /* eslint-disable-line react/forbid-component-props */ style={{ width }}
        {...listProps}
      >
        <VirtualList
          data={data}
          height={height}
          itemHeight={itemHeight}
          itemKey={itemKey}
        >
          {renderItem}
        </VirtualList>
      </DisplayList>
    );
  }

  return (
    <DisplayList {...listProps} dataSource={data} renderItem={renderItem} />
  );
};
